import gsap from 'gsap';

const arrowAnimation = gsap.timeline({paused: true})
    .to('.sec-1__arrow', { duration: 1.35, y: -20, yoyo: 1, repeat: -1, delay: 1 });

if($('.sec-1__link').length) {
    const mailAnimation = gsap.timeline({repeat: -1, repeatDelay: 2.4})
        .to('.sec-1__link', { rotation: 10, duration: .1})
        .to('.sec-1__link', { rotation: -10, duration: .1})
        .to('.sec-1__link', { rotation: 10, duration: .1})
        .to('.sec-1__link', { rotation: -10, duration: .1})
        .to('.sec-1__link', { rotation: 10, duration: .1})
        .to('.sec-1__link', { rotation: -10, duration: .1})
        .to('.sec-1__link', { rotation: 10, duration: .1})
        .to('.sec-1__link', { rotation: -10, duration: .1})
        .to('.sec-1__link', { rotation: 0, duration: .1});
}

$('.sec-1__link').on('click', (e) => {
    e.preventDefault();
    promokitStore.page.to($(e.currentTarget).attr('href'));
});

export default {
    id: '#section-1',
    name: 'INTRO',
    backgroundVideo: promokit.video({
        el: '.sec-1__video',
        url: 'https://vod.plaync.com/Aion/update/201015/Classic_Loop_low.mp4',
        preload: true,
        mute: true,
        loop: true
    }),
    enterEnd() {
        arrowAnimation.play();
    }
};



// WEBPACK FOOTER //
// ./src/js/section-1.js